<template>
  <div>
    <footer class="footer d-none d-lg-block">
      <div class="container">
        <div class="row footer-row">
          <div class="col-sm-9 col-xs-9">
            <div class="row footer-menu">
              <nav id="navbar">
                <ul class="nav navbar-nav collapse">
                  <li v-for="(item, i) in nav" :key="i">
                    <a :href="item.link">{{ item.text }}</a>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="row footer-info">
              <div class="col-sm-12 col-xs-12">
                <p>© Национальное Беговое Движение, 2016-{{ new Date().getFullYear() }}, All rights reserved, АНО ЦРМС
                  «Марафон Плюс»
                  (ОГРН 1147600031105)</p>
                <p>
                  <a
                    href="http://run-rus.com/files/documents/Политика%20в%20отношении%20обработки%20ПДн_Марафон%20Плюс.pdf"
                    class="main_content_footer_item">
                    Политика в отношении обработки ПД в АНО ЦРМС «Марафон Плюс»
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-xs-3 footer-contacts">
            <ul class="contact_menu">
              <li class="contact_item">
                <p class="contact_item_header">Контакты</p>
              </li>
              <li class="contact_item">
                <a href="tel:8(4852)33-02-71" class="contact_item_link">8(4852)33-02-71</a>
              </li>
              <li class="contact_item">
                <a href="mailto:kalendar@run-rus.com" class="contact_item_link">kalendar@run-rus.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    <footer class="footer-mobile d-lg-none">
      <p>Национальное Беговое Движение {{ new Date().getFullYear() }}</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'FooterNbd',
  data () {
    return {
      nav: [
        {
          text: 'Услуги и поддержка',
          link: 'https://run-rus.com/organizer.html'
        },
        {
          text: 'Календарь',
          link: 'https://events.run-rus.com/'
        },
        {
          text: 'Чемпионаты',
          link: 'https://champs.run-rus.com/'
        },
        {
          text: 'Клубы',
          link: 'https://clubs.run-rus.com/'
        },
        {
          text: 'Обучение',
          link: 'https://edu.run-rus.com/'
        },
        {
          text: 'Об НБД',
          link: 'https://run-rus.com/about.html'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  $footer-color: $color-white;
  $footer-bg: #015b81;
  $footer-bg-mobile: #108cce;

  // grid
  .container {
    padding-left: 15px;
    padding-right: 15px;
    max-width: 1200px;
  }

  .row {
    margin-left: -15px;
    margin-right: -15px;

    &::after {
      clear: both;
    }
  }

  .row, .container, .nav {

    &::before, &::after {
      content: " ";
      display: table;
    }
  }

  .col-sm-3, .col-sm-9, .col-sm-12 {
    float: left;
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
  }

  @media (min-width: 768px) {
    .col-sm-3 {
      width: 25%;
    }

    .col-sm-9 {
      width: 75%;
    }

    .col-sm-12 {
      width: 100%;
    }
  }

  // mobile
  .footer-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60px;
    width: 100%;
    font-size: 12px;
    color: $color-white;
    background: $footer-bg-mobile;
  }

  // desktop
  .footer {
    font-size: 14px;
    line-height: 1.42857;
    position: relative;
    padding-top: 30px;
    height: auto;
    background-color: $footer-bg;
    color: $color-white;
    -webkit-font-smoothing: initial;
    -moz-osx-font-smoothing: initial;

    h4, p {
      font-size: 15px;
      font-weight: 300;
      color: $footer-color;
    }

    a {
      color: $color-white;
      text-decoration: none;
    }
  }

  .footer-row {
    padding-left: 30px;
  }

  .footer-menu {

    li {
      width: 50%;
      margin: 0;
      display: inline-block;
    }
  }

  .footer-info {
    font-weight: 300;
    text-align: center;

    > div {
      padding: 0;
    }
  }

  .contact_menu {
    display: flex;
    flex-direction: column;
    list-style-type: none;
    justify-content: space-around;
    margin-bottom: 0;
    padding-left: 40px;
  }

  .contact_item_header {
    padding: 0;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 18px;
  }

  .contact_item_link {
    transition: all .3s;
    color: $color-white;
    line-height: 1.65;
    font-size: 16px;
  }

  .navbar-nav {
    column-count: 3;
    column-gap: 2.5em;
    float: none;
    display: flex;
    text-align: center;
    margin-bottom: 6px;

    li {
      float: right;
      padding: 0;
      margin: 0 0 6px;
      list-style: none;
    }

    a {
      font-size: 15px;
      transition: .3s;
      line-height: 20px;
      position: relative;
      display: block;

      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>
